module.exports = __webpack_public_path__ + "img/avatar4.e0d9c682.png";